//=require third-party/rAF.js
//=require third-party/jquery.min.js
//=require third-party/modernizr.js
//=require third-party/owl.carousel.js
//=require third-party/lazysizes.js
//=require third-party/underscore-throttle.js
//=require third-party/jquery.matchHeight-min.js
//=require third-party/basicScroll.min.js
//=require third-party/jquery.fancybox.js

// import Cookies from './modules/cookies';

/******************************************************************************************
SCREEN SIZES
******************************************************************************************/

var navBreakpoint = 1180;
if (document.querySelector('.nav--reduced')) {
	navBreakpoint = 9999;
}
var desktopNavQuery = `only all and (min-width: ${navBreakpoint}px`;

function isDesktopNav() {
	return Modernizr.mq(desktopNavQuery);
}

/******************************************************************************************
LOCK/UNLOCK BODY FROM SCROLLING
******************************************************************************************/

function lockBody() {
	var body = $('body'),
		header = $('.site-header'),
		bodyScrollPos = $(window).scrollTop(),
		bodyWidthBeforeNavOpen = $('body').width();

	body.css({
		'position': 'fixed',
		'top': -bodyScrollPos + 'px',
		'left': '0',
		'right': '0'
	});
	// if there was a scrollbar on page, add some padding of same width to body so whole page doesn't shift
	var scrollbarWidth = $('body').width() - bodyWidthBeforeNavOpen;
	// also add to header and nav panels so they don't shift around
	console.log('scrollbarWidth: ' + scrollbarWidth);
	if (scrollbarWidth > 0) {
		body.css({
			'paddingRight': scrollbarWidth + 'px'
		});
		header.css({
			'marginRight': scrollbarWidth + 'px'
		});
	}
}
function unlockBody() {
	var body = $('body'),
		header = $('.site-header'),
		bodyScrollPos = -parseInt(body.css('top'));

	// if body isn't already locked, don't do anything
	if (body.css('position') != 'fixed') return;

	// reset the styles we added to body, header and nav panels when we locked the page
	body.css({
		'position': '',
		'top': '',
		'left': '',
		'right': '',
		'paddingRight': ''
	});
	header.css({
		'marginRight': ''
	});

	$(window).scrollTop(bodyScrollPos);
}

/******************************************************************************************
STICKY NAV
******************************************************************************************/

var header = $('.js-site-header'),
	currentScrollPos = 0;

$(window).on('scroll resize load', _.throttle(function() {

	// if we're auto-scrolling after closing a "read more" link or accordion, don't change header state
	if (navIsLocked) return false;
	
	// headerOffset is used when header doesn't start at top of viewport, eg WJ home page
	var headerOffest = 0,
		oldScrollPos = currentScrollPos,
		headerHeight = header.outerHeight();

	currentScrollPos = $(window).scrollTop() - headerOffest;

	// ----- CHECK IF IT WAS A PROPER SCROLL ----

	// If we've moved less than 5px in last 100ms, and we've not just very slowly crept to top of the page, don't do anything
	if (Math.abs(currentScrollPos - oldScrollPos) < 5 && currentScrollPos != 0) return false;

	// ----- APPLY SOME CLASSES ----

	// if we're at top of page (or before where header would go offscreen on WJ home page), show our normal, relative-positioned header
	if (currentScrollPos <= -headerOffest) {
		header.removeClass('site-header--is-fixed site-header--is-hidden');
	}
	// if we've just scrolled up but aren't yet at very top, show "fixed" header
	else if (currentScrollPos < oldScrollPos && currentScrollPos > -headerHeight) {
		header.removeClass('site-header--is-hidden').addClass('site-header--is-fixed');
	// if we're just scrolled down and are past point where we'd be able to see header, set header to "hidden"
	} else if (currentScrollPos >= oldScrollPos && currentScrollPos > headerHeight) {
		header.removeClass('site-header--is-fixed site-header--nav-is-open').addClass('site-header--is-hidden');
	// otherwise, show our normal, relative-positioned header
	} else {
		header.removeClass('site-header--is-fixed');
	}
}, 100));

/******************************************************************************************
LOCK/UNLOCK/RESET NAV
*******************************************************************************************/

var navIsLocked = false;

function lockNav() {
	navIsLocked = true;
	// console.log('nav locked');
}
function unlockNav() {
	// adds a bit of extra time to catch accidental scrolls, or timed functions overlapping
	setTimeout(function () {
		navIsLocked = false;
		// console.log('nav unlocked');
	}, 100);
}
function resetNav() {
	console.log('resetNav called');
	var navBtn = $('.site-header__nav-btn'),
		navBtnActiveClass = 'site-header__nav-btn--is-active',
		nav = $('.nav');
	navBtn.removeClass(navBtnActiveClass);
	nav.hide();
	unlockNav();
	unlockBody();
}

/******************************************************************************************
OPEN/CLOSE WHOLE NAV/SUB-NAVS ON SMALLER SCREENS
*******************************************************************************************/

(function () {
	var navBtn = $('.site-header__nav-btn'),
		navBtnActiveClass = 'site-header__nav-btn--is-active',
		nav = $('.nav'),
		navLinksWithSubNavs = $('.nav__link:not(:last-child)'),
		navLinkOpenClass = 'nav__link--is-open';

	// open/close whole nav

	navBtn.click(function (e) {
		e.stopPropagation(); // stop clicks inside nav bubbling down to body and triggering nav close
		navBtn.toggleClass(navBtnActiveClass);
		if (navBtn.hasClass(navBtnActiveClass)) {
			nav.slideDown(300);
			lockNav();
			lockBody();
			nav.scrollTop(0); // reset scroll position of nav when we open it
		} else {
			nav.slideUp(300);
			unlockNav();
			unlockBody();
		}
	});

	// open/close subnavs
	
	navLinksWithSubNavs.click(function(e) {
		if (!isDesktopNav()) {
			e.preventDefault();
			$(this).toggleClass(navLinkOpenClass);
			$(this).siblings('.nav__sub-nav').slideToggle();
		}
	});

	// close mobile nav when body is clicked

	$('body').click(function () {
		if (!isDesktopNav() && nav.is(':visible')) {
			navBtn.click();
		}
	});

	$('.site-header').click(function (e) {
		e.stopPropagation(); // stop clicks inside header/nav bubbling down to body and triggering nav close
	});
	
})();

/******************************************************************************************
RESET NAV/BODY LOCK WHEN SWITCHING TO DESKTOP
******************************************************************************************/

(function () {
	var wasDesktopNav = isDesktopNav();
	$(window).on('resize', _.throttle(function () {
		if (isDesktopNav() != wasDesktopNav) {
			wasDesktopNav = isDesktopNav();
			resetNav();
		}
	}, 100));
})();

/******************************************************************************************
SCROLL TO ELEMENT
*******************************************************************************************/

function scrollToElement (element) {
	// stop nav changing on scroll
	lockNav();
	// get top of our element
	var targetY = element.offset().top;
	// subtract height of nav if it's a sticky one...
	if ($('.site-header').hasClass('site-header--is-fixed')) {
		targetY -= $('.site-header').outerHeight(true);
	}
	$('html, body').animate({
		scrollTop: targetY
	}, 800, function() {
		// re-enable nav
		unlockNav();
	}
	);
}

/******************************************************************************************
ANIMATE IN ELEMENTS ON SCROLL
******************************************************************************************/

// trigger animations that need triggering

function checkAnimations () {
	var delay = 100; // delay before first visible item is triggered
	$('[data-animate]').each(function () {
		// if this element is inside of an owl carousel item and is not currently visible, don't animate it yet
		if ($(this).closest('.owl-item').length && !$(this).closest('.owl-item').hasClass('active')) {
			return;
		}
		// if element more than 25% higher than the fold (and it's top is not zero, which means owl carousel is working on it), trigger animation
		if ($(window).scrollTop() + ($(window).height() * .75) > $(this).offset().top && $(this).offset().top != 0) {
			var animatedElement = $(this),
				animationType = animatedElement.attr('data-animate');
			animatedElement.removeAttr('data-animate');
			// then trigger animation after specified delay
			setTimeout(function () {
				// fade in
				if (animationType == 'fade-in') {
					animatedElement.animate({ 'opacity': 1 }, 800);
					// count up
				} else if (animationType == 'count-up') {
					// grab target number from our span we saved earlier
					var span = animatedElement.find('span'),
						targetNumber = span.attr('data-target-number'),
						number = 0;
					// then every fraction of a second...
					var increaseNumber = setInterval(function () {
						// add a 200th of our total
						number = Math.min(number + (targetNumber / 100), targetNumber);
						// output current number, removing decimal places and adding thousands separator
						span.html(Math.ceil(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
						// if we've hit our target, stop calling this function
						if (Math.ceil(number) >= targetNumber) {
							clearInterval(increaseNumber);
							return;
						}
					}, 10);
					// trigger css animation
				} else if (animationType == 'css-animation') {
					animatedElement.addClass('is-animating');
				}
			}, delay);
			// increase our delay by the amount specified on this element
			delay += parseInt(animatedElement.attr('data-animate-delay') ? animatedElement.attr('data-animate-delay') : 300);
		}
	});
}

// prep animations

if ($('[data-animate]').length) {
	// prep animations
	$('[data-animate]').each(function () {
		var animationType = $(this).attr('data-animate');
		if (animationType == 'fade-in') {
			// don't fade in on mobile
			// if (screen_size == 'small') {
			// 	$(this).removeAttr('data-animate');
			// 	return;
			// }
			$(this).css('opacity', '0');
		} else if (animationType == 'count-up') {
			var html = $(this).html().trim(),
				number = html.match(/[\d,.]+/g);
			// if this doesn't contain a recognisable number, do nothing
			if (!number) {
				$(this).removeAttr('data-animate');
			} else {
				var htmlChunks = html.split(number[0]);
				// turn result of regex into actual number
				number = parseInt(number[0].replace(',', ''));
				$(this).html(htmlChunks[0] + '<span data-target-number="' + number + '">0</span>' + htmlChunks[1]);
			}
		}
	});
	// check if animations need triggering whenever page is loaded or scrolled
	$(window).on('scroll resize', _.throttle(function () {
		checkAnimations();
	}, 100));
	// also check if they need triggering a bit after page loads, as things might have moved around a bit and made something visible
	setTimeout(checkAnimations, 400);
}

/******************************************************************************************
PARALLAX
******************************************************************************************/

var doingParallax = $('html').hasClass('no-touchevents');

if (doingParallax) {
	$('.parallax').not('.parallax--disabled').each(function () {
		var pContainer = $(this),
			pContent = $(this).children();
		$(window).on('scroll resize load', function () {

			// stop parallax from adjusting itself when nav opens and body gets fixed and changes height
			if (navIsLocked) return false;

			var imageAtScreenTop = pContainer.offset().top, // scroll point at which top of image should line up with top of it's container
				imageScrollAmount = pContent.outerHeight() - pContainer.outerHeight(), // amount image should scroll while whole image is still visible
				scrollPos = $(window).scrollTop(), // our current scroll position
				pAmount;
			// if image is a little way into page, use imageAtScreenTop to calculate parallax amount (ensures image just clears container as it gets to top of screen)
			if (imageAtScreenTop > 0) {
				pAmount = scrollPos / imageAtScreenTop; // 0-1
				// otherwise devide by enough to look OK!
			} else {
				pAmount = scrollPos / 100; // 0-1
			}

			// if parallax object is out of view, don't bother changing CSS on it...
			if (scrollPos > pContainer.height() + pContainer.offset().top) {
				return;
			}

			pContent.css({
				transform: 'translateY(' + (pAmount * imageScrollAmount) + 'px)'
			});
		});
	});
}

/******************************************************************************************
PARALLAX (using basicscroll.js)
******************************************************************************************/

// slide in ragged-topped sections, except the one after the home page video

$(':not(.home-header) + .section--ragged, .section--ragged + .section').each(function() {
	basicScroll.create({
		elem: $(this)[0],
		from: 'top-bottom',
		to: 'top-middle',
		direct: true,
		props: {
			'top': {
				from: '200px',
				to: '0',
				timing: 'cubicOut'
			}
		}
	}).start();
});

$('.a-fade-in').each(function() {
	basicScroll.create({
		elem: $(this)[0],
		from: 'top-bottom',
		to: 'middle-middle',
		direct: true,
		props: {
			'--opacity': {
				from: .01,
				to: .99
			}
		}
	}).start();
});

$('.a-slide-up').each(function() {
	basicScroll.create({
		elem: $(this)[0],
		from: 'top-bottom',
		to: 'top-middle',
		direct: true,
		props: {
			'--top': {
				from: '200px',
				to: '0',
				timing: 'cubicOut'
			}
		}
	}).start();
});

$('.a-parallax-fast').each(function() {
	basicScroll.create({
		elem: $(this)[0],
		from: 'top-bottom',
		to: 'bottom-top',
		direct: true,
		props: {
			'--top': {
				from: '60px',
				to: '-60px'
			}
		}
	}).start();
});

$('.a-parallax-slow').each(function() {
	basicScroll.create({
		elem: $(this)[0],
		from: 'top-bottom',
		to: 'bottom-top',
		direct: true,
		props: {
			'--top': {
				from: '-60px',
				to: '60px'
			}
		}
	}).start();
});

/******************************************************************************************
ACCORDIONS
******************************************************************************************/

$('.js-accordion-heading').click(function() {

	var aHeading = $(this);

	// is accordion enabled at this size?
	var disableFrom = aHeading.get(0).hasAttribute('data-disable-accordion-from') ? aHeading.attr('data-disable-accordion-from') : 999999;
	if ( $(window).width() >= disableFrom ) {
		return;
	}

	aHeading.toggleClass('js-accordion-heading--is-open');
	// tell our nav not to be effected by any scrolling that's about to happen
	lockNav();
	// toggle relevant content
	aHeading.next('.js-accordion-content').slideToggle(400, function() {
		// re-enable nav
		unlockNav();
	});
	// when we open one, close all others
	if (aHeading.is('.js-accordion-heading--is-open')) {
		// calculate where this heading is going to end up so we can scroll to it
		// get current position of heading
		var targetY = aHeading.offset().top;
		// subtract height of any accordion content that's open and above (as page is going to shift up by that much)
		$('.js-accordion-heading--is-open').each(function() {
			if ($(this).offset().top < aHeading.offset().top) {
				targetY -= $(this).next('.js-accordion-content').outerHeight(true);
			}
		});
		// also subtract height of nav if it's a sticky one...
		if ($('.site-header').hasClass('site-header--is-fixed')) {
			targetY -= $('.site-header').outerHeight(true);
		}
		// now close all siblings
		$('.js-accordion-heading--is-open').not(aHeading).removeClass('js-accordion-heading--is-open').next('.js-accordion-content').slideUp();
		// and scroll to our open one, if it's going to be off the top of the screen
		if (targetY < $('html').scrollTop()) {
			$('html, body').animate({
				scrollTop: targetY
			}, 400, function() {
				// re-enable nav
				unlockNav();
			}
			);
		} else {
			unlockNav();				
		}

	}
});

/******************************************************************************************
OWL CAROUSELS
*******************************************************************************************/

$('.owl-carousel').each(function() {
	var donation = $(this).hasClass('owl-carousel--donation');
	var owl = $(this),
		owlOptions = {
			dots: true,
			nav: true,
			loop: false,
			items: 1,
			dotsContainer: owl.next('.owl-carousel-nav').find('.owl-carousel-nav__dots'),
			navContainer: owl.next('.owl-carousel-nav'),
			responsive: {
				700: {
					items: 2
				},
				1100: {
					items: donation ? 4 : 3
				}
			},
			onTranslated: function () {
				checkAnimations();
			}
		},
		disableFrom = owl.get(0).hasAttribute('data-disable-owl-from') ? owl.attr('data-disable-owl-from') : null;


	// if we're showing this owl at all sizes, it's simple!
	if (!disableFrom) {
		owl.owlCarousel(owlOptions);
		return;
	}

	// otherwise we need to enable/disable it at the breakpoint specified on our html tag
	// based on http://stackoverflow.com/questions/28251644/disabling-owl-carousel-at-a-specific-viewport-width
	if ( $(window).width() < disableFrom ) {
		owl.owlCarousel(owlOptions);
	} else {
		owl.addClass('off');
	}
	$(window).resize(function() {
		if ( $(window).width() < disableFrom ) {
			if ( owl.hasClass('off') ) {
				owl.owlCarousel(owlOptions);
				owl.removeClass('off');
			}
		} else {
			if ( !owl.hasClass('off') ) {
				owl.addClass('off').trigger('destroy.owl.carousel');
				owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
			}
		}
	});
});

/******************************************************************************************
PHOTO GALLERIES
******************************************************************************************/

$('.gallery').each(function () {
	var gallery = $(this),
		links = gallery.find('a');
	links.fancybox({
		loop: true,
		margin: [76, 94],
		gutter: 16,
		idleTime: false,
		buttons: [
			'thumbs',
			'close'
		]
	});
});

/******************************************************************************************
EQUAL HEIGHTS (for when CSS won't do it)
*******************************************************************************************/

// $('.entry-list__entry__heading').matchHeight();

/******************************************************************************************
SHARE LINKS
*******************************************************************************************/

if ($('.share').length) {
	$('.share li:not(\'.em\') a').click(function() {
		window.open($(this).attr('href'), 'share', 'height=380,width=600,toolbar=0,location=0,menubar=0');
		return false;
	});
}

/******************************************************************************************
SMOOTH SCROLL (to all # links)
*******************************************************************************************/

$('a[href*="#"]:not([href="#"])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var targetElement = $(this.hash);
		targetElement = targetElement.length ? targetElement : $('[name=' + this.hash.slice(1) +']');
		scrollToElement($(targetElement));
	}
});

/******************************************************************************************
AJAX FORMS
*******************************************************************************************/

// based on https://solspace.com/craft/freeform/docs/ajax-forms/
const freeformForm = document.querySelector('.js-ajax-freeform');

if(freeformForm) {
	freeformForm.addEventListener('freeform-render-success', function (event) {
		// Prevent the default behavior
		event.preventDefault();
	});

	freeformForm.addEventListener('freeform-render-form-errors', function (event) {
		// Prevent the default behavior
		event.preventDefault();
	});

	freeformForm.addEventListener('freeform-render-field-errors', function (event) {
		// Prevent the default behavior
		event.preventDefault();
	});
}

$('.js-ajax-freeform').on({
	submit: function () {
		var $self = $(this);
		if ($self.is('[data-ajax]')) {
			console.info('custom ajax submission stopped');
			return;
		}
		$('.form__messages').children().remove();
		$('button[type=submit]', $self).prop('disabled', true);

		$.ajax({
			url: $('input[name=action]', $(this)).val(),
			type: 'post',
			dataType: 'json',
			data: $(this).serialize(),
			success: function (response) {
				$('ul.errors.help-block', $self).remove();
				$('.has-error', $self).removeClass('has-error');

				if (response.errors) {
					for (var key in response.errors) {
						if (!response.errors.hasOwnProperty(key)) continue;
						var messages = response.errors[key];
						var $errors  = $('<ul>', {'class': 'errors help-block'});
						for (var i = 0; i < messages.length; i++) {
							var $li = $('<li>');
							$li.html(messages[i]);
							$errors.append($li);
						}

						var $input = $('*[name=' + key + '], *[name="' + key + '[]"]');

						var $formField = $input.parents('.form__field');
						$formField.addClass('has-error');

						$formField.append($errors);

					}

					// scroll to first error
					scrollToElement($('.form__field.has-error').first());

				}

				$('button[type=submit]', $self).prop('disabled', false);
			}
		});

		return false;
	}
});
/******************************************************************************************
SEARCH BAR
*******************************************************************************************/

var searchClicked = false;

if (window.matchMedia('(max-width: 1180px)').matches) {
	searchClicked = true;
} 

$( window ).resize(function() {
	if (window.matchMedia('(max-width: 1180px)').matches) {
		searchClicked = true;
	} 
});


if (!searchClicked) {
	$('#searchbar-button').click(function (e) { 
		$('#searchbar').css('width', '66rem');
		e.preventDefault();
		$(this).unbind(e);
		
		searchClicked = true;
	});
} else {
	$('#searchbar-button').click(function () { 
		
		searchClicked = false;
	});
}


/******************************************************************************************
SEARCH FILTERS
*******************************************************************************************/

$('.expand-filter').click(function (e) { 
	e.preventDefault();
	
	var filter = $('.filter-wrap');
	
	if (!filter.hasClass('showing')) {
		filter.slideDown();
		filter.addClass('showing');
		filter.css('display', 'grid');
	} else {
		filter.slideUp();
		filter.removeClass('showing');
	}

});

$( window ).resize(function() {
	var filter = $('.filter-wrap');
	if (window.matchMedia('(min-width: 880px)').matches) {
		filter.css('display', 'grid');
	} else if (!filter.hasClass('showing')) {
		filter.css('display', 'none');
	} 
});

if (window.location.href.indexOf("sign-up-to-our-volunteer-mailing-list") > -1 || window.location.href.indexOf("sign-up-to-our-mailing-list") > -1 ) {
	$('.newsletter').remove();
	$('.site-footer').remove();
}

/******************************************************************************************
COOKIE FUNCTIONS  
*******************************************************************************************/
function setCookie(cookieName, cookieValue, expiryDays) {
	const d = new Date();
	d.setTime(d.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
	let expires = "expires="+d.toUTCString();
	document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

function getCookie(cookieName) {
	let name = cookieName + "=";
	let ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

/******************************************************************************************
DONATION FORM 
*******************************************************************************************/
const amountOptions = document.querySelectorAll('.js-amount-option');
const amountInput = document.querySelector('#Amount');
if (amountOptions && amountInput) {
	const selectedClass = 'donate__amount-button--selected';
	const resetSelectedClasses = () => Array.from(amountOptions, option => option.classList.remove(selectedClass));
	const addSelectedClass = (option) => option.classList.add(selectedClass);
	Array.from(amountOptions, (option) => {
		option.addEventListener('click', () => {
			amountInput.value = option.dataset.value;
			resetSelectedClasses();
			addSelectedClass(option);
			setCookie('donationAmount', parseFloat(amountInput.value).toFixed(2));
		});
	});
	amountInput.addEventListener('input', (e) => {
		resetSelectedClasses();
		const val = amountInput.value;
		Array.from(amountOptions, (option) => {
			const optionVal = option.dataset.value;
			const optionValAlt = option.dataset.value.includes('.') ? option.dataset.value.split('.')[0] : false;
			if (optionVal == val || optionValAlt == val) addSelectedClass(option);
		});
	});
	const donationForm = document.querySelector('[data-donation-form]');
	if (donationForm) {
		donationForm.addEventListener('submit', () => {
			setCookie('donationAmount', parseFloat(amountInput.value).toFixed(2));
			// Cookies.set('donationAmount', amountInput.value);
		});
	}
	amountInput.addEventListener('change', (e) => {
		setCookie('donationAmount', parseFloat(amountInput.value).toFixed(2));
	});
}

/******************************************************************************************
CORPORATE DONATION FORM 
*******************************************************************************************/
const corporateDonationForm = document.querySelector('[data-js-corporate-donation-form]');
if (corporateDonationForm) {

	const commentField = document.querySelector('[data-js-comment-field]');
	const furtherInfoBoxes = document.getElementsByName('further-info');
	const website = document.querySelector('[data-js-website-field]');
	const newLine = '&#13;&#10;';

	const updateCommentField = function() {
		let commentFieldContent = '';
		let websiteString = `Website: `;
		let furtherInfoSet = false;
		let furtherInfoString = `Interested in further information on:${newLine}`;
	
		if (website.value) {
			websiteString = `${websiteString}${website.value}${newLine}`;
			commentFieldContent = `${commentFieldContent}${websiteString}`
		}
	
		Array.from(furtherInfoBoxes, (option) => {
			if (!option.checked) {
				return;
			}
			furtherInfoSet = true;
			furtherInfoString = `${furtherInfoString}${newLine}- ${option.value}`;
		})
	
		if (furtherInfoSet) {
			commentFieldContent = `${commentFieldContent}${newLine}${furtherInfoString}`;
		}
	
		commentField.value = commentFieldContent;
		// console.log(commentField.value);
	}

	Array.from(furtherInfoBoxes, (checkbox) => {
		checkbox.addEventListener('change', updateCommentField);
	});

	if (website) {
		website.addEventListener('blur', updateCommentField);
	}

}

/******************************************************************************************
HOME HERO 
*******************************************************************************************/
const homeHeroHeightCalc = function() {
	const heroImage = document.querySelector('.parallax__img.parallax__img--home-header');
	const heroContent = document.querySelector('.home-header__overlay');
	if (!heroImage || !heroContent) {
		console.warn('Home hero image or content not found');
		return;
	}
	const heroImageHeight = heroImage.computedStyleMap.height;
	const heroContentHeight = heroContent.offsetHeight + 40;
	if (heroImageHeight >= heroContentHeight) {
		console.warn('Hero image height is greater than content height');
		return;
	}
	console.log('Hero image height: ' + heroContentHeight);
	heroImage.style.height = `calc(${heroContentHeight}px + 8rem)`;
}
homeHeroHeightCalc();
window.addEventListener('resize', homeHeroHeightCalc);
console.log('TEST END');